<div class="multi-tags"
   #target
   *ngIf="{
    open: (open$ | async) || false,
    selectedList: (selectedList$ | async),
    list: (list$ | async)
   } as streams$"
   (focus)="onClick()"
   (blur)="onBlur()"
   tabindex="0"
>
  <int-labeled-field-box
    [isActive]="isActive"
    [isFocus]="isOpen"
    [isError]="isError"
    [label]="label"
    [isLabelBox]="false"
  >
    <ng-container ngProjectAs="center-position">
      <div class="multi-tags__wrapper">
        <div class="multi-tags__tags-container"
           *ngIf="{tags: (selectedList$ | async) || []} as list">
          <ng-container *ngIf="!isTagsListEmpty; else tagPlug">
            <div class="select-tag" *ngFor="let tag of list.tags">
              <int-closed-tag (onClose)="deleteTag( tag, $event)">
                {{ getTagLabelByValue(tag) }}
              </int-closed-tag>
              <div class="select-tag__divider"></div>
            </div>
          </ng-container>
        </div>
      </div>
    </ng-container>
    <ng-container ngProjectAs="right-position">
      <int-dropdown-chevron (onClick)="onToggle($event)" [isActive]="isOpen"></int-dropdown-chevron>
    </ng-container>
  </int-labeled-field-box>

  <int-portal-slot
    *intInsertAfterViewInit
    [show]="isOpen"
    [targetRef]="target"
  >
    <ng-template intPortalSlotTemplate>
      <int-dropdown-area
        [id]="dropAreaID"
        [style]="{
          '--int-dropdown-area-max-height': dropdownHeight,
          '--int-dropdown-area-padding': dropDownPaddings
        }"
        tabindex="3"
        class="drop-area"
        [excludeElementsForClickOutside]="target"
        (clickOutside)="onClose()"
        (closeEvent)="onClose()"
      >
        <ng-container ngProjectAs="header">
          <ng-content select="top-list-position"></ng-content>
        </ng-container>
        <int-dropdown-list
          *ngIf="!isListEmpty; else emptyList"
          [list]="streams$.list || []"
          [selectedValues]="(selectedList$ | async) || []"
          (onClick)="onItemClick($event)"
        >
          <ng-template intDropdownItem let-payload>
            <button
              tabindex="4"
              class="list-item"
              (click)="onSelect(payload.onClick, payload.itemData, payload.index)">
            <span class="checkbox">
              <int-default-checkbox [checked]="payload.isSelected"></int-default-checkbox>
            </span>
              <span class="divider"></span>
              <span>
              {{ payload.itemData.label }}
            </span>
            </button>
          </ng-template>
        </int-dropdown-list>
      </int-dropdown-area>
    </ng-template>
  </int-portal-slot>
</div>

<ng-template #emptyList>
  <div class="empty-content">
    <ng-content select="empty-content"></ng-content>
  </div>
</ng-template>

<ng-template #tagPlug>
  <int-closed-tag class="select-tag__self" [isHide]="true">-</int-closed-tag>
</ng-template>
